export const HTTP_STATUS = {
  OK: 200,
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  UNAUTHORIZED: 401,
  SERVER_ERROR: 500,
  MAINTENANCE: 503,
  BAD_GATEWAY: 502
};
